import { render } from "./Sdsy_t.vue?vue&type=template&id=05dc97e0&scoped=true"
import script from "./Sdsy_t.vue?vue&type=script&lang=js"
export * from "./Sdsy_t.vue?vue&type=script&lang=js"

import "./Sdsy_t.vue?vue&type=style&index=0&id=05dc97e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaole\\Documents\\work\\dc\\www.tzspace.cn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dc97e0"]])

export default __exports__